import { useEffect, useRef } from "react";
import { addStudySeconds } from "../services/progressService";

/**
 * Comptabilise le temps de travail (objectif du jour, espace parents).
 * Écrit toutes les 30 s pendant que l'écran est visible ; flush au démontage.
 */
export function useStudyTimer(uid: string | undefined, active = true) {
  const pending = useRef(0);
  useEffect(() => {
    if (!uid || !active) return;
    const tick = setInterval(() => {
      if (document.visibilityState !== "visible") return;
      pending.current += 5;
      if (pending.current >= 30) {
        const s = pending.current;
        pending.current = 0;
        addStudySeconds(uid, s).catch(() => undefined);
      }
    }, 5000);
    return () => {
      clearInterval(tick);
      if (pending.current > 0) {
        const s = pending.current;
        pending.current = 0;
        addStudySeconds(uid, s).catch(() => undefined);
      }
    };
  }, [uid, active]);
}
